module.exports = __webpack_public_path__ + "img/noPhotoClient.4f1b1cfb.svg";